import { render, staticRenderFns } from "./LeccionC5.vue?vue&type=template&id=aad0a708&"
import script from "./LeccionC5.vue?vue&type=script&lang=js&"
export * from "./LeccionC5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports